$(function() {
  
    
  // Hours of Operation
  
  $('#hours').on('click', function(e)
  {
    e.preventDefault();
    e.stopPropagation();
    $('#hours-modal').fancybox({
      width: 560,
      fitToView: true
      
    });
    $('#hours-modal').trigger('click');
  });
  
  
  $('#christmas').on('click', function(e)
  {
    e.preventDefault();
    e.stopPropagation();
    $('#christmas-modal').fancybox({
      width: 900,
      fitToView: true
      
    });
    $('#christmas-modal').trigger('click');
  });
  
  
  $('#md-hours').on('click', function(e)
  {
    e.preventDefault();
    e.stopPropagation();
    $('#md-hours-modal').fancybox({
      width: 560,
      fitToView: true
      
    });
    $('#md-hours-modal').trigger('click');
  });



  $('#email-2, #email-3').on('click', function(e)
  {
    e.preventDefault();
    e.stopPropagation();
    $('#email-2-trigger').fancybox({
      width: 560,
      fitToView: true
      
    }).trigger('click');
  });  
  
  // Smooth Anchor Scroll

  $('body').on('click', 'a[href*=#]:not([href=#])', function(e)
  {
      var element = $($(this).prop('href').substring($(this).prop('href').lastIndexOf('#')));
      if (element.length)
      {
          e.preventDefault();
          $('html, body').animate({ 'scrollTop': element.offset().top - 95 }, 500);
      }
  });


    $('#christmas-landing .page').on('click', '.one-third a', function(e)
    {
        e.preventDefault();
    });
  
});